import { SvgIcon, SvgIconProps } from '@mui/material';

const SearchOutlined = ({ fill, fillOpacity, sx, ...props }: SvgIconProps) => {
  return (
    <SvgIcon
      {...props}
      data-testid="SearchOutlinedIcon"
      sx={{
        fill: fill,
        fillOpacity: fillOpacity ?? 1,
        ...sx
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.34082 4.34106C7.46191 1.21997 12.522 1.21997 15.643 4.34106C18.5243 7.22269 18.7428 11.755 16.3035 14.8901L22 20.5876L20.5873 22.0002L14.8899 16.3038C11.7547 18.7431 7.22245 18.5246 4.34082 15.6433C1.21973 12.5222 1.21973 7.46215 4.34082 4.34106ZM14.2304 5.75371C11.8896 3.4129 8.09429 3.4129 5.75347 5.75371C3.41266 8.09453 3.41266 11.8898 5.75347 14.2306C8.09432 16.5711 11.8897 16.5713 14.2304 14.2306C16.5711 11.8899 16.5708 8.09456 14.2304 5.75371Z"
      />
    </SvgIcon>
  );
};

export default SearchOutlined;
